module.exports = __webpack_public_path__ + "img/3dfile.7943178c.png";